// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2coiU","box":"WorkspacesBox_box__zpuKf","node":"WorkspacesBox_node__16DxV"};